import React, { useState } from 'react';
import { dispatcher } from 'lib/Dispatcher';
import Zendesk from './Zendesk';
import { useQuery } from '@apollo/client';
import CurrentUser from 'auth/CurrentUser';
import enumerate from 'lib/enumerate';

import { ZendeskTokenQuery, ZendeskTokenQueryVariables } from './__generated__/ZendeskTokenQuery';
import Zendesk_TOKEN_QUERY from './zendeskTokenQuery.gql';

export const ActionTypes = enumerate(['JWT_SUCCESS', 'LOGOUT']);
export type ZendeskJWT = {
  token: string;
  expiresAt: Date;
};

export default function ZendeskBot() {
  const [fetchingJwt, setFetchingJwt] = useState<boolean>(true);
  const [jwt, setJwt] = useState<string | null | undefined>(CurrentUser.getZendeskToken());

  const variables = CurrentUser.isSignedIn() ? { userUuid: CurrentUser.getUserUuid() } : undefined;

  const { loading } = useQuery<ZendeskTokenQuery, ZendeskTokenQueryVariables>(Zendesk_TOKEN_QUERY, {
    variables,
    onCompleted: (data) => {
      if (data?.api_zendeskSignedIdentity?.token) {
        const token = data.api_zendeskSignedIdentity.token.value;
        setJwt(token);
        setFetchingJwt(false);
        dispatcher.dispatch({
          type: ActionTypes.JWT_SUCCESS,
          token,
        });
      }
    },
    onError: (_) => {
      setFetchingJwt(false);
    },
    skip: !CurrentUser.isSignedIn() || !!CurrentUser.getZendeskToken(),
  });

  if (loading || fetchingJwt) return null;

  return <Zendesk token={jwt} />;
}
